import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faChevronDown, faChevronUp, faEyeSlash, faQuestion, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { AddressModel, TextModel, TimesheetAddressModel } from '@evorait/pace-core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'pace-address-select-expandable',
    templateUrl: './address-select-expandable.component.html',
    styleUrls: ['./address-select-expandable.component.scss'],
})
export class AddressSelectExpandableComponent implements OnInit {
    @Input() public readonly address: AddressModel;
    @Input() public readonly enableHideTimesheetAddress: boolean;
    @Input() public isEditable: boolean;
    @Input() public isExpanded = false;

    @Output() public toggleExpandEvent = new EventEmitter<void>();
    @Output() public selectAddressEvent = new EventEmitter<void>();
    @Output() public deleteAddressEvent = new EventEmitter<void>();
    @Output() public hideAddressEvent = new EventEmitter<void>();
    @Output() public formValidityChange = new EventEmitter<boolean>();
    @Output() public newAddressAddedEvent = new EventEmitter<TimesheetAddressModel>();
    @Output() public openHelpEvent = new EventEmitter<OpenHelpProperties>();

    public readonly faChevronDown = faChevronDown;
    public readonly faChevronUp = faChevronUp;
    public readonly faTrashAlt = faTrashAlt;
    public readonly faEyeSlash = faEyeSlash;
    public readonly faQuestion = faQuestion;

    public addressFormGroup!: FormGroup;
    public addressFormChildren!: FormArray;
    public selectedAddress: TimesheetAddressModel;
    public isCollapsed = true;
    public constructor(private readonly formBuilder: FormBuilder) {}

    public get displayAddressText(): TextModel {
        if (this.isEditable) return this.selectedAddress.addrText;
        if (this.address.addrText.value) return this.address.addrText;
        if (this.address.name1.value) return this.address.name1;
        return new TextModel('');
    }

    public ngOnInit(): void {
        this.selectedAddress = this.address.getTimesheetAddress();

        if (!this.addressFormChildren) {
            this.addressFormChildren = this.formBuilder.array([]);
        }
        if (!this.addressFormGroup) {
            this.addressFormGroup = this.formBuilder.group({
                children: this.addressFormChildren,
            });
        }
    }

    public selectAddress(): void {
        this.selectAddressEvent.emit();
    }

    public hideAddress(): void {
        this.hideAddressEvent.emit();
    }

    public deleteAddress(): void {
        this.deleteAddressEvent.emit();
    }

    public openHelp(): void {
        const openHelpProperties: OpenHelpProperties = {
            allowToHide: this.address.allowToHide && this.enableHideTimesheetAddress,
            allowToDelete: !this.address.addrNumber.value,
        };
        this.openHelpEvent.emit(openHelpProperties);
    }

    public onAddressChange(): void {
        this.newAddressAddedEvent.emit(this.selectedAddress);
    }

    public onStateChange(): void {
        this.address.statesOfUSA.selectByValue(this.selectedAddress.statesOfUSA.selectedEntry?.model.value);
    }
}

interface OpenHelpProperties {
    allowToHide: boolean;
    allowToDelete: boolean;
}
